document.addEventListener('DOMContentLoaded', () => {
  let isFetching = false;
  let observer = null;

  const initInfiniteScroll = () => {
    const trigger = document.querySelector('.infinite-scroll-trigger');
    if (!trigger) return;

    // Disconnect any existing observer before creating a new one
    if (observer) observer.disconnect();

    // The rootMargin triggers the fetch 400px BEFORE the user hits the spinner
    observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !isFetching) {
        loadNextPage(trigger);
      }
    }, { rootMargin: '0px 0px 400px 0px' });

    observer.observe(trigger);
  };

  const loadNextPage = async (trigger) => {
    let nextUrl = trigger.dataset.nextUrl;
    if (!nextUrl) return;

    isFetching = true;
    
    try {
      const response = await fetch(nextUrl);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      const new_cards = html.querySelector('.load_list');
      const new_items = new_cards.querySelectorAll('.load_item');
      const current_list = document.querySelector('.load_list');
      
      // Append the new products to the existing grid
      new_items.forEach((newItem) => {
        current_list.append(newItem);
      });

      // Update the trigger with the next page URL, or remove it if we reached the end
      const new_trigger = html.querySelector('.infinite-scroll-trigger');
      if (new_trigger && new_trigger.dataset.nextUrl) {
        trigger.dataset.nextUrl = new_trigger.dataset.nextUrl;
      } else {
        trigger.remove();
        if (observer) observer.disconnect();
      }
    } catch (error) {
      console.error('Error fetching next page for infinite scroll:', error);
    } finally {
      isFetching = false;
    }
  };

  // 1. Initialize on first page load
  initInfiniteScroll();

  // 2. Watch for AJAX filter changes
  // Your collection-filters-form.js replaces the innerHTML of #CollectionProductGrid
  const gridContainer = document.getElementById('CollectionProductGrid');
  if (gridContainer) {
    const mutationObserver = new MutationObserver(() => {
      // When filters run, the grid is replaced, so we reset our fetching state and re-initialize
      isFetching = false;
      initInfiniteScroll();
    });
    
    mutationObserver.observe(gridContainer, { childList: true, subtree: false });
  }
});